import React from 'react'
import ReactDOM from 'react-dom/client'
import styled from 'styled-components'

import { DictionaryProvider } from '@/components/shared/DictionaryProvider'

import { ThemeProvider } from '../../theme'
import { TaskPaneApp } from '../taskpane/TaskpaneApp'

const AddInWidth = styled.div`
  max-width: 450px;
`

export const WebApp = () => (
  <AddInWidth>
    <ThemeProvider>
      <DictionaryProvider>
        <TaskPaneApp />
      </DictionaryProvider>
    </ThemeProvider>
  </AddInWidth>
)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<WebApp />)
